import React, { Component } from 'react';
import '../CSS/newRecord.css';
import GenericNavbar from './Navbar/GenericNavbar';

import SimpleStorageContract from "../contracts/SimpleStorage.json";

import KaspTokens from "../contracts/KaspTokens.json";
import KaspTokenSale from "../contracts/KaspTokenSale.json";


import getWeb3 from "../utils/getWeb3";
import axios from 'axios';
import KryptoBird from '../abis/KryptoBird.json';
import Sidemenu from './Navbar/Sidemenu';

class NftFileUpload extends Component
{
    state = {
		buffer: null,
		web3: null, 
		accounts: null,
		account: null,
		contract: null,
        token:'',
        noShare:'',
        enterShare:'',
        address:'',
        totalUsd:'',
        eth:'',
        noCoin:'',
        KaspTokenSaleInstance:'',
		totalSupply: null,
		kryptoBirdz: [],
		user:null
    };

    constructor(props){
        super(props);
    }
    

    componentDidMount = async () => {
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
		if(user){
			this.setState({user:user});
		}
        if(user.tradsd.amount){
            this.setState({noShare:  user.tradsd.amount});
        }

        
        
        try {
          // Get network provider and web3 instance.
          const web3 = await getWeb3();
          // Use web3 to get the user's accounts.
          const accounts = await web3.eth.getAccounts();
          console.log(accounts[0])
            this.setState({address: accounts[0]})
			this.setState({account:accounts[0]})
          // Get the contract instance.
		  const networkId = await web3.eth.net.getId();
		  console.log(networkId)
			const networkData = KryptoBird.networks[networkId];
			console.log(networkData);
			if(networkData) {
				const abi = KryptoBird.abi;
				const address = networkData.address; 
				const contract = new web3.eth.Contract(abi, address)
				this.setState({contract})

				const totalSupply = await contract.methods.totalSupply().call()
			   this.setState({totalSupply})
			   // set up an array to keep track of tokens 
			   // load KryptoBirdz
			   for(let i = 1; i <= totalSupply; i++) {
				   const KryptoBird = await contract.methods.kryptoBirdz(i - 1).call()
				   // how should we handle the state on the front end? 
				   this.setState({
					   kryptoBirdz:[...this.state.kryptoBirdz, KryptoBird]
				   })
			   }
			} else {
				//('Smart contract not deployed')
			}

        } catch (error) {
          // Catch any errors for any of the above operations.
          alert(
            `Failed to load web3, accounts, or contract. Check console for details.`,
          );
          console.error(error);
        }
      };

	mint = (kryptoBird) => {
		console.log(this.state); 
		console.log(this.state.contract); //return
		this.state.contract.methods.mint(kryptoBird).send({from:this.state.account})
		.once('receipt', (receipt)=> {
			this.setState({
				kryptoBirdz:[...this.state.kryptoBirdz, KryptoBird]
			})
		})  
	}
    render(){
        return(
            <div className = "">
                <GenericNavbar/>
                {this.state.address &&
                <p className='wal-address'>{this.state.address } </p>
                }
                <div className="container-fluid bg-black">
                <div className="row">
				<Sidemenu />
                    <div className="col s10">
                        <div className="card reportCard">
                            <div className="card-title cardTitle2">
                                <h4 className = "cardTitle">Mint</h4>
                            </div>
                            <div className="card-content">
							<form onSubmit={(event)=>{
                                event.preventDefault()
                                console.log(this.kryptoBird.value);
                                console.log(this.state);
                                /******* */
                                const kryptoBird = this.kryptoBird.value
                                this.mint(kryptoBird);
								console.log(this.state);

                                 fetch(`
                     http://52.60.64.107/api/orginatorx-new/mint.php?name=${this.state.name}&url=${this.kryptoBird.value}&
                           desc=${this.state.desc}&title=${this.state.title}&price=${this.state.price}&account=${this.state.account}
                           &filtype=${this.state.fileType}&filesize=${this.state.fileSize}&category=${this.state.category}
						   &minPrice=${this.state.minMrice}&userId=${this.state.user.id}`)
                                 .then(response => response.json())
                                 .then(data => {
                                       this.setState({title: ''});
                                       this.setState({name: ''});
                                       this.setState({desc: 0});
                                       this.setState({price: ''});
                                       this.setState({fileType: ''});
                                       this.setState({fileSize: ''});
                                       this.setState({minMrice: ''});
									   this.kryptoBird.value = '';

                                 }); 
                                /******* */


                                /*  */
                            }}>
				<div class="box in__upload mb-120">
					<div class="row">
						<div class="col-lg-6">
							<div class="left__part space-y-40 md:mb-20 upload_file">
								<div class="space-y-20">
									<img class="icon"
										src="./img/icons/upload.svg"
										alt="" />
									<p class="color_text">PNG, GIF, WEBP, MP4 or MP3. Max
										100mb.</p>
									</div>
								
							{this.state.links}
								<div class="space-y-20">
									<input type="text" placeholder="Mint" 
                                    ref={(input)=>this.kryptoBird = input}/>
			
								</div>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="form-group space-y-11">
								<div class="space-y-20">
									<div class="space-y-11">
										<span class="nameInput">Title</span>
										<input type="text" class="form-control"
											placeholder="Title" 
                                            value={this.state.title}
                                            onChange={(e)=>this.setState({title: e.target.value}) }
                                            />
									</div>
									<div class="space-y-11">
										<span class="nameInput">Author Name<span
												class="color_text"> </span></span>
												<div className="col-lg-12">
                                    <input type="text" placeholder='Author Name' className='form-control mb-1'
                                    value={this.state.name}
                                    onChange={(e)=>this.setState({name: e.target.value }) }
                                    />
									</div></div>
									<div class="space-y-11">
										<span class="nameInput">Description <span
												class="color_text">
												(optional) </span></span>
										<input type="text" class="form-control"
											placeholder="Description" 
                                            value={this.state.desc}
                                            onChange={(e)=>this.setState({desc: e.target.value}) }
                                            />
									</div>
									<div class="space-y-11">
										<span class="variationInput">Price</span>
										<select class="form-select custom-select"
											aria-label="Default select example"
                                            value={this.state.price}
                                            onChange={(e)=>this.setState({price: e.target.value}) }
                                            >
											<option> 00.00 ETH</option>
											<option>01.00 ETH</option>
											<option>02.00 ETH</option>
											<option>10.00 ETH</option>
											<option>20.00 ETH</option>
										</select>
									</div>
									<div class="space-y-11">
										<span class="variationInput">Minimum Price</span>
										<input type="text" placeholder="ETH"
										value={this.state.minMrice}
										onChange={(e)=>this.setState({minMrice: e.target.value}) }
										  />
									</div>
									<div class="space-y-11">
										<span class="variationInput">Choose Type</span>
										<select class="form-select custom-select"
											aria-label="Default select example"
                                            value={this.state.category}
                                            onChange={(e)=>this.setState({category: e.target.value}) }
                                            >
											<option value='Games'> Games</option>
											<option value='Art'>Art</option>
											<option value='Trading'>Trading</option>
											<option value='Music'>Music</option>
											<option value='Domain'>Domain Names</option>
											<option value='Memes'>Memes</option>
											<option value='Collectibles'>Collectibles</option>
										</select>
									</div>
                                    <input style={{margin:'6px'}}
                                        type='submit'
                                        className='btn btn-primary'
                                        value='MINT'
                                        />
			
			
								</div>
							</div>
							{/* <p class="color_black">
								<span class="color_text text-bold"> Service fee : </span>
								2.5%
							</p> <p class="color_black">
								<span class="color_text text-bold"> You will receive :
								</span>
								22.425 ETH $41,637.78
							</p> */}
							<p>
			
			
							</p>
						</div>
					</div>
				</div>
                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default NftFileUpload;
